import { render } from "./ViewCopyMove.vue?vue&type=template&id=6eadacf6&scoped=true"
import script from "./ViewCopyMove.vue?vue&type=script&lang=js"
export * from "./ViewCopyMove.vue?vue&type=script&lang=js"

import "./ViewCopyMove.vue?vue&type=style&index=0&id=6eadacf6&lang=scss&scoped=true"

import exportComponent from "/app/tmp/bambl/V3/v2026.33.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6eadacf6"]])

export default __exports__